import {
  CREATE_NEW_AD,
  DELETE_AD,
  DUPLICATE_AD,
  GET_ADS,
  GET_ADS_STATS,
  GET_QF_CREATIVES_STATS,
  MODIFY_AD,
} from "./actionTypes"
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  createNewAdError,
  createNewAdSuccess,
  deleteAdError,
  deleteAdSuccess,
  duplicateAdError,
  duplicateAdSuccess,
  getAdsError,
  getAdsStatsError,
  getAdsStatsSuccess,
  getAdsSuccess,
  getQfCreativesStatsError,
  getQfCreativesStatsSuccess,
  modifyAdError,
  modifyAdSuccess
} from "./actions"
import {
  deleteCreativeAd,
  genericGetRequest,
  postCreateAd,
  postDuplicateAd,
  putModifyAd,
} from "../../helpers/sf_backend_helper";

import { AppConfiguration } from "config";
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils"

// Fetch All Ads
function* getAdsForAccount(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/ads`,
      action.payload?.queryParams,
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": action?.payload?.show_rtb_brand_ui_changes ? action?.payload?.brand_id : getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getAdsSuccess(response, action.payload?.time_frame_key))
  } catch (error) {
    yield put(getAdsError(error))
  }
}




function* createNewAdForAccount(ad) {
  try {
    let user_auth = localStorage.getItem("authUser")
    ad["token"] = JSON.parse(user_auth).user.token
    ad["account_id"] = JSON.parse(user_auth).user.account_id
    const response = yield call(
      postCreateAd,
      `${AppConfiguration.BACKEND_URL}/api/v1/ads`, ad
    )
    yield put(createNewAdSuccess(response.data))
    ad.payload.history.push("/creatives")
  } catch (error) {
    yield put(createNewAdError(error))
  }
}

// Modify Ad
function* modifyAdForAccount(ad) {
  try {
    let user_auth = localStorage.getItem("authUser")
    ad["token"] = JSON.parse(user_auth).user.token
    ad["account_id"] = JSON.parse(user_auth).user.account_id
    const response = yield call(
      putModifyAd,
      `${AppConfiguration.BACKEND_URL}/api/v1/ads/${ad.payload.ad.id}`, ad
    )
    yield put(modifyAdSuccess(response.data))
    ad.payload.history && (ad.payload.history.push("/creatives"))
  } catch (error) {
    yield put(modifyAdError(error))
  }
}

// duplicate Ad
function* duplicateAd(ad) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      postDuplicateAd,
      `${AppConfiguration.BACKEND_URL}/api/v1/duplicate_ads`, {
      ad: ad.payload,
      token: JSON.parse(user_auth).user.token,
      account_id: JSON.parse(user_auth).user.account_id,
    }
    )
    yield put(duplicateAdSuccess(response.data))
  } catch (error) {
    yield put(duplicateAdError(error))
  }
}

// duplicate Ad
function* deleteAd(ad) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      deleteCreativeAd,
      `${AppConfiguration.BACKEND_URL}/api/v1/ads/${ad.payload.id}`, {
      ad: ad.payload,
      token: JSON.parse(user_auth).user.token,
      account_id: JSON.parse(user_auth).user.account_id,
    }
    )
    yield put(deleteAdSuccess(response))
  } catch (error) {
    yield put(deleteAdError(error))
  }
}

function* onGetAdsStatsForAccount(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    let endpoint = '/api/v1/ad_stats'
    if (action.payload?.use_v3_api_for_ad_stats) {
      endpoint = '/api/v3/ad_stats'
    }
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      action.payload?.queryParams,
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getAdsStatsSuccess(response, action.payload?.time_frame_key))
  } catch (error) {
    yield put(getAdsStatsError(error))
  }
}

function* onGetQfCreativesStatsForAccount(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v4/qf_creatives_stats`,
      action.payload?.queryParams,
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getQfCreativesStatsSuccess(response, action.payload?.time_frame_key))
  } catch (error) {
    yield put(getQfCreativesStatsError(error))
  }
}

function* AdSaga() {
  yield takeEvery(CREATE_NEW_AD, createNewAdForAccount);
  yield takeEvery(MODIFY_AD, modifyAdForAccount);
  yield takeEvery(GET_ADS, getAdsForAccount);
  yield takeLatest(GET_ADS_STATS, onGetAdsStatsForAccount);
  yield takeLatest(GET_QF_CREATIVES_STATS, onGetQfCreativesStatsForAccount);
  yield takeEvery(DUPLICATE_AD, duplicateAd);
  yield takeEvery(DELETE_AD, deleteAd);
}


export default AdSaga;
